import { createPatchEndpoint } from '@sonar-software/sonar-http';

import { DataSensitivityLevelId, FieldUsageId } from '@types';

export type PatchSalesforceSonarObjectsBulkRequest = {
	complianceCategory?: number;
	dataSensitivityLevelId?: DataSensitivityLevelId;
	fieldUsageId?: FieldUsageId;
	sonarObjectIds: Array<number>;
};

export type PatchSalesforceSonarObjectsBulkResponse = {
	success: boolean;
	taskId: number;
};

export const patchSalesforceSonarObjectsBulk = createPatchEndpoint<
	PatchSalesforceSonarObjectsBulkRequest,
	PatchSalesforceSonarObjectsBulkResponse
>('/api/v3/salesforce/sonar-objects/bulk/start');
